import { styled } from '../../stitches.config';
import { MultiComboBoxPopover } from '../MultiComboBox/MultiComboBox';
import { ComboBoxPopover } from './ComboBox';

/**
 * Used for showing additional information in the rendered selected items but not in the options, useful for inlining any <Section> titles in the rendered badges.
 */
export const HideInComboBoxPopover = styled('div', {
  [`${MultiComboBoxPopover} &`]: {
    display: 'none',
  },
  [`${ComboBoxPopover} &`]: {
    display: 'none',
  },
});
HideInComboBoxPopover.displayName = 'HideInComboBoxPopover';
